/**
 * useReducedMotionSync (B10) — keeps store.reducedMotion equal to the OS
 * setting, live (matchMedia change listener). The layout root mirrors it as
 * data-motion="reduced", which the design CSS turns into 160 ms fades.
 * Returns the current store value.
 */
import { useEffect } from "react";
import { actions, getApp, useApp } from "@/store/store";

export const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

export function useReducedMotionSync(): boolean {
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return undefined;
    const mq = window.matchMedia(REDUCED_MOTION_QUERY);
    const apply = () => {
      if (getApp().reducedMotion !== mq.matches) actions.setReducedMotion(mq.matches);
    };
    apply();
    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", apply);
      return () => mq.removeEventListener("change", apply);
    }
    mq.addListener(apply); // Safari < 14
    return () => mq.removeListener(apply);
  }, []);
  return useApp((s) => s.reducedMotion);
}
